import { cva } from 'class-variance-authority';

import { cn } from '@heidi/utils';

import { formFieldDescriptionText, formFieldTitleText } from '../styles/form-field';
import { labelControlStateClasses } from './label.styles';

/**
 * Experimental Label styles (DS-1504 / DS-1506), behind
 * `release-experimental-design-system-forms`. Stable is `text-sm` alone, so the
 * label inherits 400 and matches its own value — the reason ~25 call sites
 * hand-add `font-medium`.
 *
 * The text roles themselves (title / description / error) live in
 * `../styles/form-field` — they dress the whole field group, not just Label.
 */

export const labelVariantsExperimental = cva(
  cn(formFieldTitleText, labelControlStateClasses)
);

/** Title size at 400, subtler tint — the title stays the only bold element. */
export const labelDescriptionClassesExperimental = formFieldDescriptionText;

/**
 * The wrapper, not the label, is the toggle's sibling, so it carries the peer
 * states: title and description dim together; only a bound label takes cursors.
 */
export const labelWithDescriptionClasses = cn(
  'flex flex-col gap-0.5',
  'peer-[:is([role=checkbox],[role=radio],[role=switch]):disabled]:opacity-70',
  'peer-[:is([role=checkbox],[role=radio],[role=switch]):enabled]:[&>label[for]]:cursor-pointer',
  'peer-[:is([role=checkbox],[role=radio],[role=switch]):disabled]:[&>label[for]]:cursor-not-allowed'
);
